export default __webpack_public_path__ + "static/media/index.0deefb06.svg";